import React from 'react';

import { InvitationList } from '@components/utilities/Friend/InvitationList';

export const InvitationsReceived: React.FC = () => <InvitationList role="recipient" />;
